import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux'
import clsx from 'clsx';

import * as actions from '../../../store/actions'

import validate from 'validate.js';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Button,
  Typography
} from '@mui/material';

import withErrorHandler from '../../../hocs/withErrorHandler'
import axios from '../../../httpClients/axios-datamerch'

import useClasses from '../../../helpers/useClasses';



const styles = theme => ({
  root: {}
});

const UploadPercentWarningDialog = React.memo(props => {
  const { className, open, user_id, user, onUploadPercentWarningDismiss } = props;
   
  const classes = useClasses(styles);
  const [openDialog, setOpenDialog] = useState(false);

  const onCloseClick  = (event) => {
    onUploadPercentWarningDismiss(user_id)
    if (event.target.matches('button, input[type="button"]')) {
        setOpenDialog(false);
    }
  }

  useEffect(() => {
    setOpenDialog(user.account_total_ninety_days_contribution_percentage < 0.5 && (user.upload_percent_warning_dismiss === null))
  },[user])

  
  return (
    <Dialog
      className={clsx(classes.root, className)}
      onClose={onCloseClick}
      maxWidth={'md'}
      open={openDialog}
      disableEscapeKeyDown={true}
    >
      <DialogTitle id="form-dialog-title">Sharing Contribution Warning</DialogTitle>
      <Divider />
        <DialogContent>
            <Typography
                sx={{
                        marginTop: '15px'
                    }}
                variant="subtitle2"
            >
                Your company DataMerch account is under the minimum contribution percentage of 0.5%.  Please upload default, suspicious activity, slow pay, etc. merchants to bring your contribution percentage above 0.5%. Contribution percentage is recalculated daily, or if you are an admin for your account, you can manually refresh under “account” and “contribution” tab.
            </Typography>
        </DialogContent>
        <Divider />
        <DialogActions>
            <Button
            color="secondary"
            variant="contained"
            onClick={(event) => onCloseClick(event)}
            >
            Dismiss
            </Button>
        </DialogActions>
    </Dialog>
  );
});


const mapStateToProps = state => {
    return {
        user_id: state.auth.user.resource_id,
        user: state.auth.user
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onUploadPercentWarningDismiss: (user_id) => dispatch(actions.uploadPercentWarningDismiss(user_id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(UploadPercentWarningDialog, axios))